import { ISitemapField } from 'next-sitemap';

type TypeExtraConfig = {
  changefreq: ISitemapField['changefreq'];
  priority: ISitemapField['priority'];
};

type TypeConfig = {
  forms: {
    [key: string]: number;
  };
  maxProducts: number;
  sitemap: {
    extraConfig: TypeExtraConfig;
    items: string[];
  };
  session: {
    woocommerce: 'woo-session';
  };
  idPagePromotions: number;
  apps: {
    ios?: {
      id: number;
      url: string;
    };
  };
};

export const config: TypeConfig = {
  forms: {
    christmas: 809739,
    joinBigcrafters: 3795,
    acelerateCraftsmen: 800536,
    contact: 3222,
    getOldOrders: 828594,
    modifySubscription: 2019,
    cancelOrder: 1932,
  },
  maxProducts: 50,
  sitemap: {
    extraConfig: {
      changefreq: 'daily',
      priority: 0.7,
    },
    items: ['brands', 'categories', 'pages', 'products', 'sellers'],
  },
  session: {
    woocommerce: 'woo-session',
  },
  idPagePromotions: 808712,
  apps: {},
};
